module.exports = __webpack_public_path__ + "static/media/ico_date.31f18591.svg";